<template>
  <div class="administration-news-wrapper">
    <div class="news-header">
      <h2 v-if="$route.query.type === 'news'">Новини</h2>
      <h2 v-if="$route.query.type === 'media'">Медиите за нас</h2>
      <h2 v-if="$route.query.type === 'gallery'">Галерия</h2>
      <h2 v-if="$route.query.page === 'message'">Съобщение</h2>
      <button @click="openNewsModal()">НОВА ПУБЛИКАЦИЯ</button>
    </div>
    <div class="news-container">
      <div
        class="news-item"
        v-for="n in news.news"
        :key="n._id"
        @click="newsModal = true, selectedNews = n._id"
      >
        <p>
          <span class="news-item-date">{{n.date | formatDateDot}}</span>
          {{n.bg.title}}
        </p>
      </div>
      <Pagination v-if="news.total" :total="news.total" :page="page" :size="size"/>
    </div>
    <transition name="fade">
      <NewsModal v-if="newsModal" :id="selectedNews"/>
    </transition>
  </div>
</template>

<script>
import NewsModal from './NewsModal';
import Pagination from '../../shared/Pagination';
export default {
  components: {
    NewsModal,
    Pagination
  },
  data() {
    return {
      newsModal: false,
      page: 1,
      size: 14,
      type: 'news',
      news: [],
      selectedNews: null
    };
  },
  watch: {
    $route() {
      this.getNews();
    }
  },
  methods: {
    openNewsModal() {
      this.newsModal = true;
    },
    changePage(p) {
      this.page = p;
      this.getNews();
    },
    closeNewsModal(refresh) {
      this.newsModal = false;
      this.selectedNews = null;
      if (refresh) {
        this.getNews();
      }
    },
    getNews() {
      this.type = this.$route.query.type;

      let url = `${process.env.VUE_APP_BASE_URI}/news?type=${this.type}&size=${
        this.size
      }&page=${this.page}`;

      this.$http
        .get(url)
        .then(result => {
          this.news = result.data;
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  mounted() {
    this.getNews();

    this.$on('page-changed', this.changePage);
    this.$on('close-news-modal', this.closeNewsModal);
  },
  destroyed() {
    this.$off('page-changed');
    this.$off('close-news-modal');
  }
};
</script>

<style lang="scss" scoped>
.administration-news-wrapper {
  width: 900px;
  margin: 0 auto;
}
.news-header {
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  margin-top: 10px;
  width: 100%;
  h2 {
    color: #004785;
    font-size: 14px;
    font-weight: 500;
  }
  button {
    background-color: $mainColor;
  }
}
.news-container {
  margin: 0 auto;
  width: 100%;
}
.news-item {
  background-color: #fff;
  cursor: pointer;
  margin-bottom: 10px;
  padding: 15px;
  @include transition(all 0.3s);
  .news-item-date {
    color: #cdd8e2;
    display: inline-block;
    margin-left: 5px;
    margin-right: 20px;
  }
  p {
    color: #14478a;
    font-size: 12px;
    font-weight: 500;
  }
}
.news-item:hover {
  background-color: $bgColor3;
  opacity: 0.8;
}
@media screen and (max-width: 1280px) {
  .administration-news-wrapper {
    width: 100%;
    // margin: 0 auto;
  }
}
@media screen and (max-width: 1000px) {
  .administration-news-wrapper {
    display: none;
  }
}
</style>

